module.exports = __webpack_public_path__ + "img/jpg-bg@3x.182236f2.png";